import { Box, Chip, IconButton, ListItem, ListItemText, Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import type { StartListGroup } from '../../types/startList';
import { AGE_SUBCATEGORY_LABELS } from '../../types/individualEntry';

interface Props {
  group: StartListGroup;
  onEdit: () => void;
  onDelete: () => void;
}

export function StartListGroupRow({ group, onEdit, onDelete }: Props) {
  const subs = group.ageSubcategories ?? [];
  const subsLabel = subs.length > 0
    ? subs.map((s) => AGE_SUBCATEGORY_LABELS[s]).join(', ')
    : group.target === 'TEAM' ? 'Družstva (bez věkového omezení)' : 'Bez věkového omezení';

  return (
    <ListItem
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        mb: 1,
        pr: 12,
      }}
      secondaryAction={
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Upravit">
            <IconButton size="small" onClick={onEdit}>
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Smazat">
            <IconButton size="small" color="error" onClick={onDelete}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      }
    >
      <ListItemText
        primary={
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Box component="span" sx={{ fontWeight: 600 }}>{group.name}</Box>
            <Chip
              size="small"
              icon={group.target === 'TEAM' ? <GroupsIcon /> : <PersonIcon />}
              label={group.target === 'TEAM' ? 'Družstva' : 'Jednotlivci'}
              variant="outlined"
            />
            <Chip size="small" label={`${group.parallelLanes} drah${group.parallelLanes === 1 ? 'a' : group.parallelLanes < 5 ? 'y' : ''}`} />
          </Stack>
        }
        secondary={subsLabel}
      />
    </ListItem>
  );
}
